import { Pipe, PipeTransform } from '@angular/core';
import { UmbracoImage } from '@models/umbraco.model';
import { CropModes, ImageFormats } from '@shared/image/image.config';
import { imageScale } from '@shared/image/helper/image-scale';

@Pipe({
    name: 'imageScale',
    standalone: true
})
export class ImageScalePipe implements PipeTransform {
    transform(
        image: UmbracoImage,
        width: number,
        height: number,
        crop: CropModes = 'crop',
        format?: ImageFormats,
        quality: number = 75
    ): string {
        return imageScale(image, width, height, crop, format, quality);
    }
}
